module.exports = function(app) {
	app.directive('ngEscape', ngEscape);
	ngEscape.$inject=['$rootScope','$parse','$state','$timeout'];
	function ngEscape($rootScope,$parse, $state, $timeout) {
		return {
			link: function (scope, element, attrs) {
				$rootScope.ngEscapeAttrsParametars.push({parametar:attrs.parametar,method:attrs.ngEscape});
				angular.element(document).off('keyup').on('keyup', function(event) {
		            if (event.which === 27) {
		            	if($rootScope.ngEscapeAttrsParametars.length ===0) {
		            		return
		            	}
		            	if($rootScope.modalShow) {
			            	for(var i=0;i<$rootScope.ngEscapeAttrsParametars.length;i++) {
								if($rootScope.ngEscapeAttrsParametars[i].parametar =='modal') {	
			                    	scope.$apply(function () {
			                        	scope.$eval($rootScope.ngEscapeAttrsParametars[i].method);
			                    	});
			                    	$rootScope.ngEscapeAttrsParametars.splice(i,1);
			            		}
			            	}
		            	} else {
		            		for(var i=0;i<$rootScope.ngEscapeAttrsParametars.length;i++) {
			            		if($rootScope.ngEscapeAttrsParametars[i].parametar =='page') {
									if($state.is('app.allposts')) {
						  				$timeout($rootScope.closeEditPost, 10);
						  			}
						  			if($state.is('app.allpages')) {
						  				$timeout($rootScope.closeEditPage, 10);
						  			}
						  			if($state.is('app.allpolls')) {
						  				$timeout($rootScope.closeEditPoll, 10);
						  			}
						  			if($state.is('app.library')) {
						  				$timeout($rootScope.closeEditMedia, 10);
						  			}
						  			if($state.is('app.allusers')) {
						  				$timeout($rootScope.closeEditUser, 10);
						  			}
						  			if($state.is('app.tags')) {
						  				$timeout($rootScope.closeEditTag, 10);
						  			}
						  			if($state.is('app.categories')) {
						  				$timeout($rootScope.closeEditCategory, 10);
									}
									if($state.is('app.allvideos')) {
										$timeout($rootScope.closeEditVideo, 10);
									}  
									if($state.is('app.allcountries')) {
										$timeout($rootScope.closeEditCountryRestriction, 10);
									} 
									if($state.is('app.ai_all_configurations')) {
										$timeout($rootScope.closeEditConfiguration, 10);
									}
									$rootScope.ngEscapeAttrsParametars=[];
									angular.element(document).off('keyup')
			            		}
			            	}
		            	}
		            	event.preventDefault();
		            }
				});
	        }
	    }
	}	
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/ngEscapeDirective.js
// module id = 443
// module chunks = 0